import { ProduktlinieVhvKautionEntry } from './produktlinie-vhv-kaution-entry.model';

export class ProduktlinieVhvKaution {

    produktlinien: ProduktlinieVhvKautionEntry[] = [];

    public doDeserialize(input: any): ProduktlinieVhvKaution {
        this.produktlinien = [];

        if (input?.['produktlinien']) {
            for (const entry of input['produktlinien']) {
                this.produktlinien.push(new ProduktlinieVhvKautionEntry().doDeserialize(entry));
            }
        }

        return this;
    }

}
